import { render, staticRenderFns } from "./LikeDislike.vue?vue&type=template&id=d721c49e&scoped=true"
import script from "./LikeDislike.vue?vue&type=script&lang=js"
export * from "./LikeDislike.vue?vue&type=script&lang=js"
import style0 from "./LikeDislike.vue?vue&type=style&index=0&id=d721c49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d721c49e",
  null
  
)

export default component.exports